import { OUTPUT_TTL } from '../../../constants/Pac';
import type RootStore from '../../root-store';

/**
 * Aerator controller
 *
 * @param rootStore
 * @param aeratorId
 * @param turnOn
 */
export const aeratorSwitch = (
  rootStore: RootStore,
  aeratorId: number,
  turnOn: boolean = true,
): void => {
  const { batchStore, devicesStore } = rootStore;

  if (aeratorId) {
    const aerator = devicesStore.getDeviceById(aeratorId);

    if (aerator?.switchPNo) {
      if (turnOn && aerator.autoTurnOn === false) {
        return;
      }

      if (batchStore.isOutputOn(aerator.switchPNo) === turnOn) {
        return;
      }

      batchStore.setOutput(aerator.switchPNo, turnOn ? OUTPUT_TTL : '0');
    }
  }
};
